module.exports = __webpack_public_path__ + "static/img/5.b31df93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soft/5.jpg
// module id = rPNb
// module chunks = 13